// Paint the invoice HTML into an already-mounted iframe. Replacing `srcDoc`
// reloads the frame (blank flash + font refetch) on every keystroke; after the
// first write we only refresh the style tag and body so the document stays up.

function isStyledElement(node: Element): node is HTMLElement {
    return "style" in node;
}

export function showNativeInvoicePreviewPage(
    doc: Document,
    pageIndex: number,
): void {
    const pages = doc.querySelectorAll(".page");
    const visibleIndex = Math.min(
        Math.max(pageIndex, 0),
        Math.max(pages.length - 1, 0),
    );
    pages.forEach((page, index) => {
        if (!isStyledElement(page)) {
            return;
        }
        const isVisible = index === visibleIndex;
        page.style.display = isVisible ? "" : "none";
        page.style.marginBottom = isVisible ? "0" : "";
    });
}

export function writeNativeInvoicePreviewHtml(
    iframe: HTMLIFrameElement,
    html: string,
    pageIndex = 0,
): void {
    const iframeDocument = iframe.contentDocument;
    if (!iframeDocument) {
        return;
    }

    const isHydrated = iframeDocument.body?.querySelector(".page") != null;
    if (!isHydrated) {
        iframeDocument.open();
        iframeDocument.write(html);
        iframeDocument.close();
        showNativeInvoicePreviewPage(iframeDocument, pageIndex);
        return;
    }

    const parsed = new DOMParser().parseFromString(html, "text/html");
    const nextStyle = parsed.querySelector("style")?.textContent ?? "";
    const currentStyle = iframeDocument.querySelector("style");
    if (currentStyle && currentStyle.textContent !== nextStyle) {
        currentStyle.textContent = nextStyle;
    }
    iframeDocument.body.innerHTML = parsed.body.innerHTML;
    showNativeInvoicePreviewPage(iframeDocument, pageIndex);
}
